import { render, staticRenderFns } from "./AutocompleteSentence.vue?vue&type=template&id=3db25877&lang=pug&"
import script from "./AutocompleteSentence.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSentence.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteSentence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports